import { action } from '../../../appLogic/appActions';

export const CREATE_COMMENT = action('CREATE_COMMENT');
